import { defineMessages } from "react-intl";

export const messages = defineMessages({
    defaultDownloadName: {
        id: "analyze.defaultDownloadName",
        defaultMessage: "analyzeResult",
    },
    question1: {
        id: "analyze.question1",
        defaultMessage: "What Fields have a soil nutrient deficiency?",
    },
    question2: {
        id: "analyze.question2",
        defaultMessage:
            "What Fields are deficient in the same nutrient in both soil and tissue tests?",
    },
    question3: {
        id: "analyze.question3",
        defaultMessage:
            "What Fields are deficient in tissue test but not soil test of the same nutrient?",
    },
    aiWarning: {
        id: "analyze.aiWarning",
        defaultMessage: "* Analyze uses AI and can make mistakes.",
    },
    result: {
        id: "analyze.result",
        defaultMessage: "Analysis Result:",
    },
    select: {
        id: "analyze.select",
        defaultMessage: "Select Analysis:",
    },
});

export const errorMessages = defineMessages({
    invalidSelectionError: {
        id: "analyze.invalidSelectionError",
        defaultMessage: "Please select an Analysis type and at least 1 Field.",
    },
    invalidSelectionModalTitle: {
        id: "analyze.invalidSelectionModalTitle",
        defaultMessage: "Required",
    },
    invalidFieldsWarning: {
        id: "analyze.invalidFieldsWarning",
        defaultMessage:
            "The following Fields do not have the required data to be included in this Analysis:{fieldsText}",
    },
    invalidFieldsModalTitle: {
        id: "analyze.invalidFieldsModalTitle",
        defaultMessage: "Validation Errors",
    },
    genericModalTitle: {
        id: "analyze.genericModalTitle",
        defaultMessage: "Error",
    },
    generic: {
        id: "analyze.generic",
        defaultMessage: "An unexpected error has occurred in the analyze API",
    },
});
